import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import {
  BackendService,
  DataHelperService,
  BobtailStore
} from './index';

@Injectable()
export class InsuranceService {
  truckValue;
  truckRate;
  trailerValue;
  trailerRate;
  towingAndStorage;
  stateTaxPercent;
  nonTruckingLiability;
  um;
  naicooaMembership;
  truckRange = [];
  trailerRange = [];
  above60k;
  above60kFactor;

  constructor(
    private _backend: BackendService,
    private _store: Store<any>,
    private _helper: DataHelperService
  ) {
    this._store.select('cvform').subscribe((store: BobtailStore) => {
      if (
        this._helper.isEmptyObject(store.steps) &&
        this._helper.isEmptyObject(store.settings) ||
        !store.steps.preliminary
      ) { return false; }

      // 60k toggle
      this.above60k = (() => {
        const arrLength = store.settings['bobtail.formulae.physical.damage.truck'].length;
        const maxValue = parseInt(store.settings['bobtail.formulae.physical.damage.truck'][arrLength - 1]['from'], 10);
        if (this.currencyToNumber(store.steps.preliminary.truckValue) >= maxValue) {
          this.above60kFactor = store.settings['bobtail.formulae.physical.damage.truck'][arrLength - 1]['y_percent'];
          return true;
        } else {
          this.above60kFactor = null;
          return false;
        }
      })();

      // get data from preliminary step
      this.truckValue = store.steps.preliminary['truckValue'] ? this.currencyToNumber(store.steps.preliminary['truckValue']) : 0;
      this.trailerValue = store.steps.preliminary['trailerValue'] ? this.currencyToNumber(store.steps.preliminary['trailerValue']) : 0;
      this.towingAndStorage = store.steps.preliminary['towingAndStorage'] ? parseInt(store.steps.preliminary['towingAndStorage'], 10) : 0;

      // get data from settings
      this.stateTaxPercent = store.settings['bobtail.constants.state.il.tax'];

      this.nonTruckingLiability = parseFloat(this.above60k ?
        store.settings['bobtail.constants.non-trucking.liability.over.60k'] :
        store.settings['bobtail.constants.non-trucking.liability']);

      // this.um = store.settings['bobtail.constants.um'];
      this.um = parseFloat(store.settings['bobtail.constants.um'] || 0);

      // this.naicooaMembership = store.settings['bobtail.constants.naicooa.membership'];
      this.naicooaMembership = parseFloat(this.above60k ?
        store.settings['bobtail.constants.naicooa.membership.over.60k'] :
        store.settings['bobtail.constants.naicooa.membership']);

      this.truckRange = store.settings['bobtail.formulae.physical.damage.truck'];
      // console.log(this.truckRange);
      this.trailerRange = store.settings['bobtail.formulae.physical.damage.trailer'];
      // console.log(this.trailerRange);
    });
  }

  getTruckRate() {
    return this.truckValue ? Math.round(this.calculateRange(this.truckValue, this.truckRange, true)) : 0;
  }

  getTrailerRate() {
    // get trailer rate only if trailer value is set (diff than 0)
    // console.log('TRAILER Range:');
    // console.log(this.trailerRange);
    // console.log('TRAILER Range:');
    // console.log('VRUSHTAME TRAILER RANGE: ' + this.trailerRange + 'TRAILER VALUE :' + this.trailerValue);
    return this.trailerValue ? Math.round(this.calculateRange(this.trailerValue, this.trailerRange, false)) : 0;
  }

  getStateSLTax() {
    let truckRate = this.getTruckRate();
    let trailerRate = this.getTrailerRate();
    let tax = parseFloat(this.stateTaxPercent);
    if ((tax === 0)) { return 0; }
    return Math.round((tax / 100) * (truckRate + trailerRate + this.towingAndStorage));
  }

  getMonthlyRate() {
    return Math.round(
      this.getTruckRate() +
      this.getTrailerRate() +
      this.getStateSLTax() +
      this.towingAndStorage +
      this.nonTruckingLiability +
      this.um +
      this.naicooaMembership);
  }

  calculateRange(value, ranges, isTruck) {
    return ranges.reduce((prev_range, range, i, arr) => {
      let min = this.num(range.from);
      let max = this.num(range.to);
      let y = this.num(range.y);
      // let y_percent = this.num(range.y_percent);
      const y_percent = parseFloat(range.y_percent);

      if (this.above60kFactor && isTruck === true) {
        // console.log('TRUCK SUM: ' + isTruck);
        return ((y_percent / 100) * value) / 12;
      }

      // match found, stop searching
      if (prev_range) { return prev_range; }

      // search ranges
      if (
        (value >= min && value < max) || // in range
        ((i === (arr.length - 1)) && !prev_range) || // last range
        (max === 0) // just in case
      ) {
        if (y) {
          // console.log('vryshtam samo Y: ' + y);
          return y;
        } else {
          // console.log('Vrushtam Y_PERCENT: ' + y_percent + ' TOTAL: ' + ((y_percent / 100) * value) / 12 + 'Is Truck: ' + isTruck);
          return ((y_percent / 100) * value) / 12;
        }
      }

      // no match found
      return null;
    }, null);
  }

  num(val) {
    return parseFloat(val);
  }

  currencyToNumber(value) {
    if (!isNaN(value)) {
      value = value.toString();
    }
    return value ? parseFloat(value.split(',').join('').replace('$', '')) : 0;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./resources/themes/pandax/bobtail/app/shared/insurance.service.ts